import store from 'store'
import { getterTypes } from 'store/auth'

export default (to, from, next) => {
  if (store.getters[getterTypes.isLoggedIn] === true) {
    return next()
  }
  return next({ name: 'Login', query: { redirect: to.fullPath } })
}
